import { NavLink } from "react-router"

import { SidebarMenuButton, SidebarMenuItem } from "./ui/sidebar.tsx"

export default function NavButton({
  label,
  to,
  icon,
}: {
  label: string
  to: string
  icon?: React.ReactNode
}) {
  return (
    <SidebarMenuItem>
      <NavLink to={to}>
        {({ isActive }) => (
          <SidebarMenuButton isActive={isActive}>
            {icon}
            <span>{label}</span>
          </SidebarMenuButton>
        )}
      </NavLink>
    </SidebarMenuItem>
  )
}
